import { z } from 'zod'
import { generatedAssetSchema } from './ai-studio-asset'

/** Credit cost of one refine generation (one image edit). */
export const REFINE_CREDIT_COST = 400

export const refineImageRequestSchema = z.object({
  prompt: z.string().min(1).max(500),
})

export type RefineImageRequest = z.infer<typeof refineImageRequestSchema>

export const refineImageResponseSchema = z.object({
  asset: generatedAssetSchema,
})

export type RefineImageResponse = z.infer<typeof refineImageResponseSchema>
